/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_right_5 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data portability`)
};

const es_privacy_right_5 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portabilidad de datos`)
};

const de_privacy_right_5 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenübertragbarkeit`)
};

const nl_privacy_right_5 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gegevensoverdraagbaarheid`)
};

const fr_privacy_right_5 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portabilité des données`)
};

const it_privacy_right_5 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portabilità dei dati`)
};

const pt_br2_privacy_right_5 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portabilidade de dados`)
};

const pt_privacy_right_5 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portabilidade dos dados`)
};

const ja_privacy_right_5 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`データポータビリティ`)
};

const zh_privacy_right_5 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数据可携性`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_right_5 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_right_5(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_right_5", locale)
	if (locale === "en") return en_privacy_right_5(inputs)
	if (locale === "es") return es_privacy_right_5(inputs)
	if (locale === "de") return de_privacy_right_5(inputs)
	if (locale === "nl") return nl_privacy_right_5(inputs)
	if (locale === "fr") return fr_privacy_right_5(inputs)
	if (locale === "it") return it_privacy_right_5(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_right_5(inputs)
	if (locale === "pt") return pt_privacy_right_5(inputs)
	if (locale === "ja") return ja_privacy_right_5(inputs)
	return zh_privacy_right_5(inputs)
};